<template>
    <div class="news_item">
        <nuxt-link class="news_inner block" :to="$getArticleLink(article)">
            <div class="news_head flex flex_center">
                <div class="date">
                    {{ article.createdAt | dateOnly }}
                </div>
            </div>
            <div class="news_body">
                <h3>{{ article.name }}</h3>
                <p>
                    {{ article.description }}
                </p>
            </div>
        </nuxt-link>
    </div>
</template>

<script>
export default {
    props: {
        article: {
            type: Object,
            required: true
        }
    }
};
</script>
